import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";

export const MobileCTA = () => {
  const [phone, setPhone] = useState("");
  useEffect(() => { api.get("/content").then((r) => setPhone(r.data.settings?.settings?.phone || "")).catch(() => {}); }, []);

  return (
    <div className="xl:hidden fixed bottom-0 inset-x-0 z-[90] glass border-t border-[#D4AF37]/20 grid grid-cols-2" data-testid="mobile-cta-bar">
      <a href={phone ? `tel:${phone}` : "/contact"} className="flex items-center justify-center gap-2 py-4 text-white font-semibold text-sm border-r border-white/10" data-testid="mobile-call-btn">
        <Phone size={17} className="text-[#D4AF37]" /> CALL
      </a>
      <Link to="/contact" className="flex items-center justify-center gap-2 py-4 nm-gold-bg text-[#0B132B] font-bold text-sm" data-testid="mobile-getstarted-btn">
        GET STARTED <ArrowRight size={15} />
      </Link>
    </div>
  );
};
